import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Footers = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  padding: 64px 0 36px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: #12151c;
`;

export default function Footer() {
  const authMember = null;

  return (
    <Footers className="site-footer">
      <Container>
        <Stack className="footer-main" flexDirection={"row"} sx={{ mt: "94px" }}>
          <Stack className="footer-brand-col" flexDirection={"column"} style={{ width: "340px" }}>
            <Box>
              <Stack direction="row" spacing={0.5} alignItems="center" className="brand brand--footer">
                <img className="nav-brand-mark-img" src="/icons/qamar-logo.png" alt="Qamar Books logo" />
                <span className="brand-title">Qamar Books</span>
              </Stack>
            </Box>
            <Box className={"foot-desc-txt"}>
              Curated books, calm discovery, and support when you want it—made
              for readers who still love turning a real page.
            </Box>
            <Box className="sns-context">
              <img src={"/icons/facebook.svg"} alt="Facebook" />
              <img src={"/icons/twitter.svg"} alt="Twitter" />
              <img src={"/icons/instagram.svg"} alt="Instagram" />
              <img src={"/icons/youtube.svg"} alt="YouTube" />
            </Box>
          </Stack>
          <Stack className="footer-link-area" sx={{ ml: "288px" }} flexDirection={"row"}>
            <Stack className="footer-link-col">
              <Box>
                <Box className={"foot-category-title"}>Explore</Box>
                <Box className={"foot-category-link"}>
                  <Link to="/">Home</Link>
                  <Link to="/products">Books</Link>
                  {authMember && <Link to="/orders">Orders</Link>}
                  <Link to="/about">Our story</Link>
                  <Link to="/help">Support</Link>
                </Box>
              </Box>
            </Stack>
            <Stack className="footer-link-col footer-link-col--visit" sx={{ ml: "100px" }}>
              <Box>
                <Box className={"foot-category-title"}>Visit</Box>
                <Box
                  flexDirection={"column"}
                  sx={{ mt: "20px" }}
                  className={"foot-category-link foot-category-link--contact"}
                  justifyContent={"space-between"}
                >
                  <Box flexDirection={"row"} className={"find-us"}>
                    <span className="find-us__label">Location</span>
                    <div>Booktown, Central</div>
                  </Box>
                  <Box className={"find-us"}>
                    <span className="find-us__label">Phone</span>
                    <div>+1 (555) 123‑4567</div>
                  </Box>
                  <Box className={"find-us"}>
                    <span className="find-us__label">Email</span>
                    <div>hello@qamarbooks.com</div>
                  </Box>
                  <Box className={"find-us"}>
                    <span className="find-us__label">Hours</span>
                    <div>Mon–Sun · 9am–9pm</div>
                  </Box>
                </Box>
              </Box>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          style={{
            border: "none",
            borderTop: "1px solid rgba(255, 255, 255, 0.12)",
            width: "100%",
          }}
          sx={{ mt: "56px" }}
        ></Stack>
        <Stack className={"copyright-txt"}>
          © {new Date().getFullYear()} Qamar Books · Crafted for curious readers
        </Stack>
      </Container>
    </Footers>
  );
}
